import React from 'react';
import { getWhatsAppUrl } from '../lib/site';

export const WhatsAppWidget = () => {
  const whatsappUrl = getWhatsAppUrl();

  return (
    <>
      {/* WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-floating-btn"
          className="group flex items-center justify-center w-16 h-16 bg-[#25D366] hover:bg-[#20BD5A] rounded-full shadow-2xl transform hover:scale-110 transition-all duration-300"
          aria-label="Chat on WhatsApp"
        >
          <svg
            viewBox="0 0 32 32"
            className="h-9 w-9 text-white fill-current"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-5.247 1.408 1.417-5.267-0.319-0.525c-1.331-2.178-2.037-4.679-2.037-7.253 0-7.51 6.11-13.62 13.62-13.62s13.62 6.11 13.62 13.62-6.11 13.62-13.62 13.62zM21.305 19.26c-0.346-0.174-2.049-1.007-2.366-1.123-0.316-0.117-0.547-0.174-0.776 0.174s-0.892 1.123-1.094 1.347c-0.201 0.231-0.403 0.26-0.748 0.087-0.346-0.174-1.461-0.539-2.785-1.722-1.031-0.922-1.727-2.061-1.929-2.407-0.201-0.346-0.022-0.533 0.152-0.705 0.156-0.155 0.346-0.403 0.518-0.605 0.174-0.201 0.231-0.346 0.346-0.576 0.117-0.231 0.058-0.433-0.028-0.605s-0.776-1.87-1.063-2.565c-0.28-0.672-0.56-0.58-0.776-0.591-0.201-0.008-0.431-0.010-0.661-0.010s-0.604 0.087-0.919 0.433c-0.316 0.346-1.206 1.179-1.206 2.873s1.235 3.333 1.406 3.561c0.174 0.231 2.441 3.732 5.913 5.234 0.827 0.358 1.472 0.572 1.975 0.733 0.831 0.263 1.586 0.226 2.184 0.138 0.666-0.099 2.049-0.838 2.335-1.647 0.289-0.808 0.289-1.501 0.201-1.647-0.087-0.143-0.316-0.231-0.662-0.403z" />
          </svg>
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full animate-ping"></span>
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full"></span>
        </a>
      </div>

      {/* Tooltip */}
      <div className="fixed bottom-24 right-6 z-40 hidden lg:block">
        <div className="bg-white rounded-2xl shadow-2xl p-4 max-w-xs border border-gray-200 animate-bounce">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center">
              <svg
                viewBox="0 0 32 32"
                className="h-5 w-5 text-white fill-current"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-5.247 1.408 1.417-5.267-0.319-0.525c-1.331-2.178-2.037-4.679-2.037-7.253 0-7.51 6.11-13.62 13.62-13.62s13.62 6.11 13.62 13.62-6.11 13.62-13.62 13.62zM21.305 19.26c-0.346-0.174-2.049-1.007-2.366-1.123-0.316-0.117-0.547-0.174-0.776 0.174s-0.892 1.123-1.094 1.347c-0.201 0.231-0.403 0.26-0.748 0.087-0.346-0.174-1.461-0.539-2.785-1.722-1.031-0.922-1.727-2.061-1.929-2.407-0.201-0.346-0.022-0.533 0.152-0.705 0.156-0.155 0.346-0.403 0.518-0.605 0.174-0.201 0.231-0.346 0.346-0.576 0.117-0.231 0.058-0.433-0.028-0.605s-0.776-1.87-1.063-2.565c-0.28-0.672-0.56-0.58-0.776-0.591-0.201-0.008-0.431-0.010-0.661-0.010s-0.604 0.087-0.919 0.433c-0.316 0.346-1.206 1.179-1.206 2.873s1.235 3.333 1.406 3.561c0.174 0.231 2.441 3.732 5.913 5.234 0.827 0.358 1.472 0.572 1.975 0.733 0.831 0.263 1.586 0.226 2.184 0.138 0.666-0.099 2.049-0.838 2.335-1.647 0.289-0.808 0.289-1.501 0.201-1.647-0.087-0.143-0.316-0.231-0.662-0.403z" />
              </svg>
            </div>
            <div>
              <p className="font-semibold text-slate-900 mb-1">Need Help?</p>
              <p className="text-sm text-slate-600">Chat with us on WhatsApp!</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
